import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../../client';
import {
  setOverrideConfiguration,
  getOverrideConfiguration,
  overrideSchedule,
  getSchedule,
  createSchedule,
  deleteOverrideByTemperature,
  deleteOverrideByScene,
} from '../../services/smartthermostat/ScheduleService';

export const useScheduleSetOverrideConfiguration = createMutationHook(
  collapseParams(collapseParams(setOverrideConfiguration, 'requestBody', 'data'), 'data', 'mode', 'duration'),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['mode', 'duration'] },
    ],
  },
);

export const useScheduleGetOverrideConfiguration = createDCHook(
  'getOverrideConfiguration',
  collapseDataFromCall(getOverrideConfiguration),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useScheduleOverrideSchedule = createMutationHook(
  collapseParams(
    collapseParams(overrideSchedule, 'requestBody', 'data'),
    'data',
    'mode',
    'sceneId',
    'temperature',
    'duration',
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['mode', 'sceneId', 'temperature', 'duration'] },
    ],
  },
);

export const useScheduleGetSchedule = createDCHook('getSchedule', collapseDataFromCall(getSchedule), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});

export const useScheduleCreateSchedule = createMutationHook(
  collapseParams(collapseParams(createSchedule, 'requestBody', 'data'), 'data', 'schedule'),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['schedule'] },
    ],
  },
);

export const useScheduleDeleteOverrideByTemperature = createMutationHook(deleteOverrideByTemperature, {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: false,
});

export const useScheduleDeleteOverrideByScene = createMutationHook(deleteOverrideByScene, {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: false,
});
